<template>
  <div>
    <b-table
      :items="services"
      :fields="fields"
    >
      <template #cell(httpsStatus)="data">
        <div v-if="getHttpsBadgeUrl(data.item.name)">
          <img
            :src="getHttpsBadgeUrl(data.item.name)"
            alt="HTTPS Status Badge"
          >
        </div>
        <div v-else>
          Nur Service-Status verfügbar
        </div>
      </template>
      <template #cell(serviceStatus)="data">
        <img
          :src="getServiceBadgeUrl(data.item.name)"
          alt="Service Status Badge"
        >
      </template>
    </b-table>
    <b-button
      variant="primary"
      @click="openStatusPage"
    >
      Zur Statusseite
    </b-button>
  </div>
</template>

<script>
import { BTable, BButton } from 'bootstrap-vue'

export default {
  components: {
    BTable, BButton
  },
  data() {
    return {
      services: [
        { name: 'Frontend' },
        { name: 'Backend' },
        { name: 'Order' },
        { name: 'Postgres' },
        { name: 'Sendgrid' },
      ],
      fields: [
        { key: 'name', label: 'Service' },
        { key: 'httpsStatus', label: 'Status HTTPS' },
        { key: 'serviceStatus', label: 'Status Service' },
      ],
    }
  },
  methods: {
    getHttpsBadgeUrl(serviceName) {
      const httpsBadges = {
        Frontend: 'https://status.der-lagermeister.de/api/badge/2/status?style=for-the-badge',
        Backend: 'https://status.der-lagermeister.de/api/badge/3/status?style=for-the-badge',
        Order: 'https://status.der-lagermeister.de/api/badge/4/status?style=for-the-badge',
        Postgres: '',
        Sendgrid: '',
      }
      return httpsBadges[serviceName] || ''
    },

    getServiceBadgeUrl(serviceName) {
      const serviceBadges = {
        Frontend: 'https://status.der-lagermeister.de/api/badge/8/uptime/24?style=for-the-badge',
        Backend: 'https://status.der-lagermeister.de/api/badge/9/uptime/24?style=for-the-badge',
        Order: 'https://status.der-lagermeister.de/api/badge/10/uptime/24?style=for-the-badge',
        Postgres: 'https://status.der-lagermeister.de/api/badge/11/uptime/24?style=for-the-badge',
        Sendgrid: 'https://status.der-lagermeister.de/api/badge/12/uptime/24?style=for-the-badge',
      }
      return serviceBadges[serviceName] || ''
    },
    openStatusPage() {
      window.open('https://status.der-lagermeister.de/status/lms', '_blank')
    },
  },
}
</script>

<style>
.text-success {
  color: green
}

.text-danger {
  color: red
}
</style>
